export default {
    name:"myfunction",
    methods: {
        _isXAdmin(userProfile) {
            return userProfile&&userProfile.role == "admin" ? true : false;
        },
        getSchool() {

        },
        getXSchoolId(str) {
            var xstrs = str.split('/')
            return xstrs[xstrs.length - 1]
        },
        formatXDate(val) {
            if (val != null) {
                if (!val) {
                    return "-";
                }
                let date = val.toDate();
                return moment(date).fromNow();
            }
            return "-";
        },
        getXXSubStr: function (string, limit) {
            if (string) return string.substring(0, limit);
            else return "";
        },
        getXSubStr: function (string, limit) {
            if (string) return string.substring(0, limit) + "...";
            else return "";
        },
        getXYoutubeId(url) {
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);

            return match && match[2].length === 11 ? match[2] : null;
        },
        getXYoutubeIframe(url) {
            if (
                url   &&
                url != "" &&
                url.toLowerCase().indexOf("youtube") != -1
            ) {
                var id = this.getXYoutubeId(url);
                return "https://www.youtube.com/embed/" + id;
            }
            return null;
        },
        getXNameWithLastName(firstName, lastName) {
            if (lastName != null && lastName.length > 0 && lastName != '')
                return lastName[0] + '.' + firstName;
            return firstName
        },
        getXLastName(lastName) {
            if (lastName != null && lastName.length > 0 && lastName != '')
                return lastName[0] + '.'
            return ''
        },
        // _ifUrlExist(url, callback) {
        //   let request = new XMLHttpRequest;
        //   request.open('GET', url, true);
        //   request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        //   request.setRequestHeader('Accept', '*/*');
        //   request.onprogress = function(event) {
        //       let status = event.target.status;
        //       let statusFirstNumber = (status).toString()[0];
        //       switch (statusFirstNumber) {
        //           case '2':
        //               request.abort();
        //               return callback(true);
        //           default:
        //               request.abort();
        //               return callback(false);
        //       }
        //   };
        //   request.send('');
        // },
        _getXXName(name) {
            return name;
        },
        _getXXPhone(name) {
            return name;
        },
        _getXXEmail(name) {
            return name;
        },
        _getXXRegister(name) {
            return name;
        },

        // _getXXName(name){
        //   if(name==null) return name;
        //   return "****";
        // },
        // _getXXPhone(name){
        //   if(name==null) return name;
        //   return name.substring(1,4)+'****';
        // },
        // _getXXEmail(name){
        //   if(name==null) return name;
        //   return name.replace('school','5432');
        // },
        // _getXXRegister(name){
        //   if(name==null) return name;
        //   return name.substring(1,4)+'****';
        // },
        async _XtravesalQA(categories) {
            for (var category of categories) {
                this.questionnaires.push({ category: true, name: category.name, count: 0 });
                for (var question of category.questions) {
                    //console.log(question);
                    for (var subquestion of question.subquestions) {
                        var finalScore;
                        if (subquestion.useranswer.correct == true)
                            finalScore = subquestion.score;
                        else
                            finalScore = 0;
                        this.finalScore = this.finalScore + finalScore;
                        this.totalScore = this.totalScore + subquestion.score
                        this.questionnaires.push({ category: false, name: subquestion.title, score: subquestion.score, finalscore: finalScore });
                        for (var answer of subquestion.answers) {
                            //console.log(answer);
                        }
                    }
                }
            }
        },
        async _getXAsuulgaCategories(qaRef) {
            this.questionCount = 0;
            if (this.categories == null || (this.categories != null && this.categories.length == 0)) {
                var ref = qaRef.collection("tests").orderBy("createdAt");
                ref.get().then(categoriesData => {
                    this.categories = [];
                    categoriesData.forEach(doc => {
                        let category = doc.data();
                        category.id = doc.id;
                        category.answeredCount = 0;
                        // if(category.questions==null || category.questions==undefined)
                        category.questions = [];
                        if (category.showquestions == null || category.showquestions == undefined)
                            category.showquestions = [];
                        this._getXAsuulgaQuestions(category, doc.ref);
                        this.categories.push(category);
                    });
                    if (this.categories != null && this.categories.length > 0)
                        this.selectedIndex = 0;
                });
            }
        },
        _getXAsuulgaQuestions(category, categoryRef) {
            if (category.questions == null || (category.questions != null && category.questions.length == 0)) {
                categoryRef.collection("questions").orderBy("createdAt").get().then(qDatas => {
                    var tmp = [];
                    qDatas.forEach(questionData => {

                        let object = questionData.data();
                        this.questionCount++;
                        object.numbering = this.questionCount;
                        object.id = questionData.id;
                        object.answers = [];
                        object.answered = false;
                        object.currentAnswerActive = false;
                        object.answeredCount = null;

                        object.subquestions = [];

                        this._getXAsuulgaSubquestions(object, categoryRef, questionData.ref, category);
                        tmp.push(object);

                    });
                    category.showquestions = this.shuffle(tmp);
                    category.questions = category.showquestions.slice();
                });
            }
        },
        _getXAsuulgaSubquestions(object, parentRef, questionRef, category) {
            if (object.subquestions == null || (object.subquestions != null && object.subquestions.length == 0)) {
                questionRef.collection("subquestions").orderBy("index").get().then(qDatas => {
                    qDatas.forEach(questionData => {
                        let sq = questionData.data();
                        // this.questionCount++;
                        //   object.numbering=this.questionCount;
                        sq.id = questionData.id;
                        sq.mcanswers = [];
                        sq.answers = [];
                        sq.answered = false;
                        // this._getAnswers(sq, questionData.ref, true, category);
                        // this._getUserAnswerSq(sq, questionData.ref, category, object);
                        this._getAnswers(sq, questionData.ref, true, category, object);
                        if (object.multichoice != true)
                            this._getUserAnswer2(sq, questionData.ref, category, object);
                        object.subquestions.push(sq);
                    });
                });
            }
        },
        _getUserAnswer2(question, ref, category, topquestion) {
            if (question.useranswer == undefined)
                question.useranswer = null;

            this.userRound.ref.collection("categories").doc(category.id).collection('roundCategoryQuestions').doc(question.id).onSnapshot(doc => {

                question.useranswer = null;
                if (doc.exists && question.multichoice != true) {
                    question.useranswer = doc.data();
                    // if(question.answered!=true && category!=null)
                    //   category.answeredCount++;

                    if (question.answered != true) {
                        if (topquestion.answeredCount == null)
                            topquestion.answeredCount = 0;
                        topquestion.answeredCount++;
                        if (topquestion.answeredCount == topquestion.subquestions.length) {
                            topquestion.answered = true;
                            if (category != null)
                                category.answeredCount++;
                        }
                    }
                    question.answered = true;
                    // question.answered=true;
                    // if(question.multichoice==true){
                    //   if(question.answeredCount==null)
                    //     question.answeredCount=0;
                    //   question.answeredCount++;
                    // }
                }
            });
        },
        _getUserAnswerText(question, ref, category) {
            var userId = 'qa_' + this.qa.id + "_user";

            if (question.useranswer == null || question.useranswer == undefined)
                question.useranswer = null;
            ref.collection("votedusers").doc($cookies.get(userId)).onSnapshot(doc => {

                question.useranswer = null;
                if (doc.exists) {
                    question.useranswer = doc.data()
                    if (question.answered != true && category != null)
                        category.answeredCount++;
                    question.answered = true;
                }
                question.currentAnswerActive = false;
            });

        },
        _getAnswers(question, ref, getResult, category, topquestion) {
            if (question.answers == null || (question.answers != null && question.answers.length == 0)) {
                if (question.answertype == true && getResult == true) {
                    this._getUserAnswerText(question, ref, category)
                }
                else {
                    ref.collection("answers").orderBy("index").get().then(querySnapshot => {
                        question.answers = [];
                        var tmp = [];
                        querySnapshot.forEach(doc => {
                            let answer = doc.data();
                            answer.id = doc.id;
                            if (question.multichoice == true && getResult == true)
                                this._getUserAnswer(answer, ref, question, category, topquestion);

                            tmp.push(answer);
                        });
                        question.answers = this.shuffle(tmp);
                    });
                }
            }
            else {
                if (question.answertype == true && getResult == true) {
                    this._getUserAnswerText(question, ref, category)
                }
                else {
                    question.answers.forEach((answer) => {
                        if (question.multichoice == true && getResult == true)
                            this._getUserAnswer(answer, ref, question, category, topquestion);
                    });

                }
            }
        },

        _getUserAnswer(answer, ref, question, category, topquestion) {

            if (answer.useranswer == undefined)
                answer.useranswer = null;
            this.userRound.ref.collection("categories").doc(category.id).collection('roundCategoryQuestions').doc(question.id).onSnapshot(doc => {

                answer.useranswer = null;
                if (doc.exists) {
                    var exists = false;
                    var index = 0;
                    if (question.answeredCount == null)
                        question.answeredCount = 0;
                    doc.data().answers.forEach((uanswer, aindex) => {
                        if (uanswer.answer.id == answer.id) {
                            exists = true;
                            index = aindex;
                        }
                    });
                    question.mcanswers = doc.data().answers;

                    if (exists == true) {
                        answer.useranswer = doc.data().answers[index];


                        if (question.answered != true) {

                            question.answeredCount++;

                            if (topquestion.answeredCount == null)
                                topquestion.answeredCount = 0;

                            topquestion.answeredCount++;

                            if (topquestion.answeredCount == topquestion.subquestions.length) {
                                topquestion.answered = true;
                                if (category != null)
                                    category.answeredCount++;
                            }
                            question.answered = true;
                        }
                        else
                            question.answered = true;
                    }
                }
            });

        },
        shuffle: function (a) {
            var j, x, i;
            for (i = a.length - 1; i > 0; i--) {
                j = Math.floor(Math.random() * (i + 1));
                x = a[i];
                a[i] = a[j];
                a[j] = x;
            }
            return a;
        },








        // v-if="userProfile && userProfile.role && (userProfile.role=='sts' || userProfile.role=='admin' )
        isXAdmin(userProfile) {
            return (userProfile && userProfile.role == "admin");
        },
        async _getSchool(fb, schoolId) {

            var schoolDoc = await fb.db.doc('schools/' + schoolId).get();
            if (schoolDoc.exists) {
                let school = schoolDoc.data();
                school.id = schoolDoc.id;
                school.ref = schoolDoc.ref;
                this.school = school
                return this.school;
            }
            return null;
        },
        getXEndScore(c) {
            // if(cellscore[2]==8) return cellscore;
            // else 
            // if(c[2]==8) {
            //     return level8?"<span class='px-1' style='background:green; color:white; font-size:10pt'>"+c[1]+"</span>": ""; 
            // }
            return c[1];
        },
        getXLevel(score) {
            if (100 >= score && score >= 90) {
                return 8;
            } else if (89 >= score && score >= 80) {
                return 7;
            }
            else if (79 >= score && score >= 70) {
                return 6;
            }
            else if (69 >= score && score >= 60) {
                return 5;
            }
            else if (59 >= score && score >= 50) {
                return 4;
            }
            else if (49 >= score && score >= 40) {
                return 3;
            }
            else if (39 >= score && score >= 30) {
                return 2;
            }
            else if (29 >= score && score >= 0) {
                return 1;
            }
        },
        getXRomNumber(level) {
            switch (level) {
                case 8: return 'VIII';
                case 7: return 'VII';
                case 6: return 'VI';
                case 5: return 'V';
                case 4: return 'IV';
                case 3: return 'III';
                case 2: return 'II';
                case 1: return 'I';
            }
        },
        _getScoreTeacherName(lesson, student) {
            for (var c of student.finalScores) {
                if (lesson.id == c[0]) {
                    return this.getXTeacherName(lesson); //+ this.isAdmin?':' + lesson.id: lesson.name;
                }
            }
            // return "<span style='background-color:black=; color:white'>"+(-1)+"</span>";;
            return -1;
        },
        _getCategoryScoreTeacherName(lesson, student, category) {
            if (category == false) {
                return this._getScoreTeacherName(lesson, student);
            }
            else {
                for (var i = 0; i < lesson.lessons.length; i++) {
                    var score = this._getScoreTeacherName(lesson.lessons[i], student);
                    if (score == -1)
                        continue;
                    else
                        return score;
                }
                //return this.NO_SCORE_FOUND;
                return "Дүнгүй учраас багш тодорxойгүй байна."
            }
        },
        _getShortName(name) {
            return name; //.substring(0,4);
        },
        deleteFbDoc(docu) {
            console.log('xxx', docu); //TODO
        },
        goToPage() {
            console.log('xxx');
        },
        getXTeacherName(lesson) {
            var lastName = null;
            if (lesson.teachers != null && lesson.teachers != undefined && lesson.teachers.length > 0) {
                if (lesson.teachers[0].lastName != null && lesson.teachers[0].lastName != '')
                    lastName = lesson.teachers[0].lastName.substring(0, 1);
            }
            // if(lesson.teachers && lesson.teachers.length>0)
            //     
            // else
            //     name = lesson.teachers[0].lastName[0];

            return lastName != null ? lastName + ". " + lesson.teachers[0].firstName : lesson.teachers[0].firstName;
            //return name;

        },
        getXTeacherNameFromLesson(lesson) {
            var teacher = lesson.teachers[0]
            var name = ''

            if (lesson.teacherLastName)
                name = name + lesson.teacherLastName

            if (lesson.teacherFirstName)
                name = name + '.' + lesson.teacherFirstName

            return name
        },
    },
    async _findCategory(schoolId, lesson) {
        var catRef = fb.db.collection("schools/" + schoolId + "/categories").doc(lesson.category.id);
        await catRef.get().then(function (doc) {
            lesson.categoryTypeId = doc.data().typeDetail.id;
            lesson.categoryTypeName = doc.data().typeDetail.name;
        }).catch(function (error) {
            console.log("Error getting cached document:", error);
        });
    },

    getXStudentLastName(student) {
        if (student.lastname && student.lastname.length > 0) {
            if (student.lncount && student.lncount > 1 && student.lastname.length >= student.lncount)
                return student.lastname.substring(0, student.lncount);
            else
                return student.lastname[0];
        }

    },

}